import React, { useState } from 'react';
import { format } from 'date-fns';

/**
 * Component to display decisions from a specific circuit
 * @param {Object} props - Component props
 * @param {Object} props.circuit - Circuit data with decisions
 */
const CircuitDecisions = ({ circuit }) => {
  const [expanded, setExpanded] = useState(false);

  if (!circuit || !circuit.decisions || circuit.decisions.length === 0) {
    return null;
  }

  return (
    <div className="circuit-decisions">
      <div 
        className="circuit-header" 
        onClick={() => setExpanded(!expanded)}
      >
        <h3>
          {circuit.name} ({circuit.decisions.length} decisions)
          <span className={`expand-icon ${expanded ? 'expanded' : ''}`}>
            {expanded ? '▼' : '►'}
          </span>
        </h3>
      </div>
      
      {expanded && (
        <ul className="circuit-decision-list">
          {circuit.decisions.map((decision) => (
            <li key={decision.id} className="circuit-decision-item">
              <span className="title-container">
                <a
                  href={decision.pdf_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="decision-link"
                >
                  {decision.case_name}
                </a>
              </span>
              <span className="decision-date">
                {format(new Date(decision.filing_date), 'MMM d, yyyy')}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CircuitDecisions;